import { FixedElementHeight } from '../constants/constants';
import { CustomEventNames } from '../constants/custom-event-names';

// clarificationUtil.ts
export function addClarificationAttributes(root: ShadowRoot | null, component: EventTarget): (event: Event) => void {
	const clickHandler = (event: Event): void => {
		handleClarificationClick(event, component);
	};
	root?.querySelectorAll('.clarification').forEach((item) => {
		item.setAttribute('tabindex', '0');
		item.setAttribute('role', 'button');
		item.setAttribute('aria-haspopup', 'true');
		item.setAttribute('aria-label', 'Klik om de toelichting te openen');
		item.addEventListener('click', clickHandler);
		item.addEventListener('keydown', (event: Event) => {
			if (event instanceof KeyboardEvent) {
				if (event.code === 'Enter' || event.code === 'Space') {
					clickHandler(event);
				}
			}
		});
		item.addEventListener('focus', () => {
			item.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
			window.scrollBy(0, FixedElementHeight);
		});
	});
	return clickHandler;
}

export function handleClarificationClick(event: Event, component: EventTarget): void {
	const clickedElement = event.target as HTMLElement;
	event.preventDefault();
	const dataId = clickedElement.getAttribute('data-id');
	const clarificationOpenEvent = new CustomEvent(CustomEventNames.OpenClarificationDialog, {
		detail: {
			id: dataId,
		},
		bubbles: true,
		composed: true,
	});
	component.dispatchEvent(clarificationOpenEvent);
}
